export enum BookingStatus {
    open ='open',
    is_use = 'is_use',
    done = 'done',
    never_used = 'never_used',
    canceled = 'canceled',
}